import { PARTNERSHIPS } from "./constants"

export const isValidPartnership = (
  val: string | undefined | null
): val is keyof typeof PARTNERSHIPS => {
  return val !== undefined && val !== null && val in PARTNERSHIPS
}
